import * as HomeyApi from 'homey-api';

import config from '../config.json';

const baseUrl = localStorage.getItem('ATHOM_CLOUD_API_BASEURL');

export const athomCloudApi = new HomeyApi.AthomCloudAPI({
  clientId: config.clientId,
  clientSecret: config.clientSecret,
  baseUrl: baseUrl ?? import.meta.env.VITE_ATHOM_CLOUD_API_BASEURL,
  redirectUrl: window.location.origin,
  autoRefreshTokens: true,
});
